import React from 'react';

const Button = () => {
  return (
    <div className="infoBand">
      <span className="infoText">&#8226; Each photo should be max. 5 MB</span>
      <span className="infoText">&#8226; You can upload max. 10 photos</span>
      <span className="infoText">&#8226; Tagging each photo is mandatory</span>
      <span className="infoText">&#8226; Supported photo formats - JPG, JPEG, PNG</span>
      <span className="infoText">&#8226; Uploaded photos cannot be modified</span>
    </div>
  )
}

export default Button;
